import { Controller, useFormContext } from 'react-hook-form';

import { NeuRadio, NeuRadioProps } from '@hcahealthcaredpx/neutron-react';

import { REQUIRED_SYMBOL } from './constants';

type RadioItem = {
  value: string;
  label: string;
  disabled?: boolean;
};

type FormRadioProps = Omit<NeuRadioProps, 'name'> & {
  name: string;
  radioOptions: Array<RadioItem>;
};

export const FormRadio = ({
  name,
  radioOptions,
  label,
  required,
  onChange,
  ...rest
}: FormRadioProps): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const errorMessage = errors?.[name]?.message as string | undefined;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <NeuRadio
          invalid={errorMessage}
          error={!!errorMessage}
          value={field.value}
          label={required ? `${label} ${REQUIRED_SYMBOL}` : label}
          required={required}
          onNeuChange={(e) => {
            field.onChange(e.value);
            onChange?.(e.value);
          }}
          {...rest}
        >
          {radioOptions.map((option, idx) => (
            <NeuRadio.Item
              key={`${name}-${idx}`}
              label={option.label}
              value={option.value}
              disabled={!!option?.disabled}
            />
          ))}
        </NeuRadio>
      )}
    />
  );
};
